<template>
    <v-dialog persistent v-model="dialog" max-width="400px">
        <v-card id="qj-dialog-configuration-approach-flow">
            <v-card-text class="pa-0">
                <v-form ref="form" lazy-validation>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12 class="pb-0">
                                <v-subheader class="px-1">E-mail</v-subheader>
                            </v-flex>
                            <v-flex xs12>
                                <v-combobox box multiple clearable small-chips hide-details hide-selected append-icon=""
                                    name="domain" label="Seleção dos e-mails por domínio" autocomplete="off" v-model="domainModel">
                                    <template v-slot:prepend-inner>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon style="font-size: 20px; cursor: help; margin-top: 2px"
                                                    color="grey" v-on="on">help</v-icon>
                                            </template>
                                            <p>
                                                Para excluir um domínio colocar um hífen antes (-gmail.com).
                                                Para utilizar somente o dominio (outlook.com).
                                            </p>
                                        </v-tooltip>
                                    </template>
                                </v-combobox>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field
                                    v-model="emailSenderPrefix"
                                    label="Endereço do remetente dos e-mails"
                                    placeholder="quiteja"
                                    clearable
                                    suffix="@domínio"
                                    hint="O domínio será escolhido conforme configurado para o credor"
                                    persistent-hint
                                    box
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field
                                    v-model="emailSenderName"
                                    label="Nome do remetente dos e-mails"
                                    placeholder="QuiteJá"
                                    clearable
                                    hint="Se não informado será usado 'QuiteJá'"
                                    persistent-hint
                                    box
                                    autocomplete="name"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions class="pr-3 pb-3">
                        <v-spacer></v-spacer>
                        <v-btn color="grey lighten-1" class="ma-0 mr-2" @click="$emit('update:dialog', false)">
                            Cancelar
                        </v-btn>
                        <v-btn color="accent" class="ma-0" @click="saveApproach">
                            Salvar
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import approachService from "@/services/consolidation-tree/approach-flow";

export default {
    props: ["dialog", "data", "approach_id", "approachFlow"],
    data() {
        return {   
            domainModel: [],
            emailSenderName: null,
            emailSenderPrefix: null,
            approachId: null,
            approach: { configurations: {} },
            rules:[
                value => (!value.length >= 1) || 'Ao editar a campanha, os contatos serão reiniciados no dia inicial da abordagem'
            ]
        };
    },
    watch: {
        async dialog() {
            if (this.dialog) {
                this.approachId = this.approach_id;
                this.configurations = { ...this.data };
                this.emailSenderName = this.configurations.email_sender_name;
                this.emailSenderPrefix = this.configurations.email_sender_prefix;
                if (this.configurations.domain && this.configurations.domain)
                    this.domainModel = this.configurations.domain;
            } else {
                this.approach = {};
            }
        },
    },
    methods: {
        saveApproach() {
            if (this.domainModel.length) {
                this.configurations.domain = this.domainModel
            } else {
                delete this.configurations.domain
            };

            if (this.emailSenderName) {
                this.configurations.email_sender_name = this.emailSenderName;
            } else {
                delete this.configurations.email_sender_name;
            }

            if (this.emailSenderPrefix) {
                this.configurations.email_sender_prefix = this.emailSenderPrefix;
            } else {
                delete this.configurations.email_sender_prefix;
            }

            this.approach.configurations = Object.assign({}, this.configurations);
            this.edit();
        },
        async edit() {
            let payload = {};
            Object.entries(this.approach).forEach(([index, item]) => {
                payload[index] = item;
            });
            await approachService
                .update(this.approachId, payload)
                .then(async (res) => {
                    this.$store.commit("showSnackbar", {
                        important: true,
                        message: `Abordagem salva com sucesso!`,
                    });
                    this.$emit("update:dialog", false);
                })
                .catch((e) => {
                    this.$store.commit("showSnackbar", `Houve um erro ao salvar!`);
                });
            window.location.reload();
        },
    },
};
</script>

<style>
#qj-dialog-stimulus .v-toolbar__content {
    padding-right: 0;
}

#qj-dialog-stimulus .v-speed-dial__list {
    align-items: end;
}

#qj-dialog-stimulus .v-speed-dial {
    bottom: 0;
}

#qj-dialog-stimulus .v-btn--floating {
    position: relative;
}

#qj-dialog-stimulus .v-avatar {
    cursor: alias;
    margin-left: 0;
}

.qj-dialog-title-input.v-input input:hover {
    border: 1px solid #6a4cb7;
    border-radius: 4px;
    padding-right: 5px;
}

.qj-dialog-title-input.v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot {
    padding-left: 0;
}

.qj-dialog-title-input.v-input__control>.v-input__slot {
    min-height: 48px;
}

.qj-dialog-title-input.v-text-field--full-width>.v-input__control>.v-input__slot {
    min-height: 28px !important;
}

.qj-dialog-title-input .v-label {
    margin-top: -12px;
}

.qj-dialog-title-input.v-input,
.qj-dialog-title-input .v-label {
    font-size: 24px !important;
    width: calc(100% - 36px);
}

.qj-dialog-title-input.v-input input,
.qj-dialog-title-input .v-label {
    padding-left: 2px;
}

.qj-dialog-title-input.v-input input:hover,
.qj-dialog-title-input .v-label:hover {
    padding-left: 1px;
}

.qj-dialog-title-input.v-input input:hover {
    border: 1px solid #6a4cb7;
    border-radius: 4px;
    padding-right: 1px;
}

.qj-dialog-title-input.v-input input:focus,
.qj-dialog-title-input .v-label:focus {
    padding-left: 0;
}

.qj-dialog-title-input.v-input input:focus {
    border: 2px solid #6a4cb7;
    border-radius: 4px;
    padding-right: 0;
}

.v-text-field--full-width.v-text-field--single-line input {
    margin-top: 0;
}
</style>
